import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { SettingsButton } from "@/Common/Components/Settings/SettingsButton";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./PreventiveRecallListSettingsContainer.module.scss";

interface IPreventiveRecallListSettingsFooterProps {
    selectedPageSizeOption: number;
    onResultsPerPageChange: (numberOfResults: number) => void;
    onColumnOrderingButtonClick?: () => void;
    onClose: () => void;
    onViewCriteria?: () => void;
    onOk: () => void;
    pageSizeOptions?: number[];
    isSaveSettingsChecked?: boolean;
    onSaveSettingsCheckboxChange?: (value: boolean) => void | null;
    footerClassName?: string;
    disableOkButton?: boolean;
}

function PreventiveRecallListSettingsFooter(props: IPreventiveRecallListSettingsFooterProps): JSX.Element {
    const { getText } = useTranslation();
    const footerClass = `f-footer flex-container ${props.footerClassName}`;

    return (
        <div className={footerClass}>
            <div className="flex-container flex-align-items-center flex-start">
                <SettingsButton
                    rightMargin={10}
                    alternativeIcon
                    onClick={() => props.onColumnOrderingButtonClick?.()}
                />
                <select
                    className={`${styles.preventiveRecallSettingsFooterFormControl} form-control`}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                        const value = parseInt(e.target.value);
                        props.onResultsPerPageChange(value);
                    }}
                    value={props.selectedPageSizeOption.toString()}
                >
                    {(props.pageSizeOptions || cacheStore.getDefaultPageSizes())
                        .map(size => <option key={size} value={size.toString()}>{size}</option>)
                    }
                </select>
                <span className="marginleft10">{getText("ResultsPerPageLabel").toUpperCase()}</span>
            </div>
            <div className="text-right">
                <span className="push-right-15">
                    <CheckboxControl
                        label={getText("RememberUserSettings")}
                        checked={props.isSaveSettingsChecked}
                        onChange={checked => props.onSaveSettingsCheckboxChange?.(checked)}
                    />
                </span>
                <ButtonControl
                    dataCy="search_settings_cancel_button"
                    className="btn btn-default push-right-5"
                    onClick={() => props.onClose()}
                    label={getText("CancelLabel")}
                />
                <ButtonControl
                    dataCy="search_settings-view_criteria_button"
                    className="btn btn-default push-right-5"
                    onClick={() => props.onViewCriteria?.()}
                    label={getText("RecallListSettings_ViewCriteriaLabel")}
                />
                <ButtonControl
                    dataCy="search_settings-ok_button"
                    className="btn btn-primary"
                    onClick={() => props.onOk()}
                    label={getText("Ok_Label")}
                    disabled={!!props.disableOkButton}
                />
            </div>
        </div>
    );
}

export { IPreventiveRecallListSettingsFooterProps, PreventiveRecallListSettingsFooter };
